import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stickyBar: {
            width: '100%',
            backgroundColor: 'background.default',
            padding: {
                base: `${remCalc(16)}`,
                md: `${remCalc(16)} ${remCalc(24)}`,
                lg: `0 ${remCalc(24)} ${remCalc(8)}`,
                xl: `0 0 ${remCalc(8)} 0`,
            },
        },
        stickyBarContent: {
            display: 'flex',
            margin: 'auto',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingTop: 'xsmall.sm',
            gap: remCalc(16),
        },
        productContainer: {
            display: 'flex',
            gap: `${remCalc(24)}`,
        },
        imageContainer: {
            display: {base: 'none', md: 'flex'},
            gap: {base: remCalc(15), lg: remCalc(26), xl: remCalc(40)},
            marginRight: {base: 'none', xl: remCalc(40)},
            flex: '0',
        },
        productImage: {
            width: `${remCalc(75)}`,
            height: `${remCalc(85)}`,
            display: {base: 'none', lg: 'block'},
        },
        productText: {
            fontWeight: 'bold',
            textStyle: 'head-xsmall',
            marginBottom: {
                base: 0,
                lg: `${remCalc(8)}`,
            },
            color: 'text.default',
            whiteSpace: {
                base: 'nowrap',
                lg: 'normal',
            },
            overflow: {
                base: 'hidden',
                lg: 'visible',
            },
            textOverflow: {
                base: 'ellipsis',
                lg: 'clip',
            },
        },
        productTextCode: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        sectionButtonGroup: {
            display: {base: 'grid', lg: 'flex'},
            gap: {base: `${remCalc(4)} ${remCalc(16)}`, xl: `${remCalc(16)}`},
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
        sectionButton: {
            color: 'text.secondary',
            textStyle: 'body-medium',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
        },
        buttonContainer: {
            width: {base: '100%', md: 'auto', lg: `${remCalc(226)}`, xl: `${remCalc(213)}`},
        },
    },
    variants: {
        paperless: {
            stickyBar: {
                overflow: 'auto',
                padding: `${remCalc(24)} ${remCalc(16)}`,
            },
            sectionButton: {
                whiteSpace: 'nowrap',
                _hover: {textDecoration: 'underline'},
                _last: {marginRight: {base: 'small.sm', lg: 'unset'}},
            },
            productText: {
                marginBottom: 'unset',
                whiteSpace: {
                    base: 'wrap',
                    lg: 'normal',
                },
                width: remCalc(250),
            },
            stickyBarContent: {
                flexDir: {
                    base: 'row',
                    lg: 'row',
                },
                gap: {
                    base: 'small.base',
                    lg: remCalc(115),
                },
                paddingTop: remCalc(0),
            },
            sectionButtonGroup: {
                display: 'flex',
                color: 'text.secondary',
            },
        },
        plpSticky: {
            buttonContainer: {
                w: {base: remCalc(168), md: 'fit-content', lg: 'fit-content', xl: 'fit-content'},
                flex: {base: '1', md: '0'},
                h: remCalc(40),
                ml: {base: 'unset', lg: 'auto'},
            },
            buttonLabel: {
                p: `${remCalc(10)} ${remCalc(24)}`,
                overflow: {base: 'hidden', md: 'visible'},
                textOverflow: {base: 'ellipsis', md: 'unset'},
                display: 'block',
                maxWidth: 'fit-content',
            },
            stickyBar: {
                padding: {
                    base: `${remCalc(24)} ${remCalc(16)}`,
                    md: `${remCalc(7)} ${remCalc(24)}`,
                    lg: `${remCalc(7)} ${remCalc(24)}`,
                    xl: `${remCalc(7)} 0`,
                },
            },
            stickyBarContent: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: {base: 'space-between', lg: 'initial'},
                gap: {base: remCalc(8), md: 0},
            },
            productContainer: {
                gap: remCalc(40),
                alignItems: 'center',
            },

            productText: {
                marginBottom: 'unset',
                textAlign: {base: 'left', md: 'center', xl: 'left'},
                whiteSpace: 'normal',
            },
            productImage: {
                display: {base: 'none', md: 'block'},
            },
        },
    },
    parts: [
        'stickyBar',
        'stickyBarContent',
        'productContainer',
        'productImage',
        'productText',
        'productTextCode',
        'sectionButtonGroup',
        'sectionButton',
        'buttonContainer',
        'buttonLabel',
    ],
}
